import { render, staticRenderFns } from "./AdminRequestStatus.vue?vue&type=template&id=68259831&scoped=true"
import script from "./AdminRequestStatus.vue?vue&type=script&lang=js"
export * from "./AdminRequestStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68259831",
  null
  
)

export default component.exports